export const generateRandomString = (
  length: number,
  possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
): string => {
  const arr = new Uint32Array(length);
  window.crypto.getRandomValues(arr);
  let text = "";
  for (let i = 0; i < length; i++) {
    text += possible.charAt(arr[i] % possible.length);
  }
  return text;
};

export const inXDays = (days: number): string => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date.toISOString().substring(0, 10);
};

// matches the postmark date style used in the backside templates, e.g. "14 SEP 2026"
export const getDefaultStampDateLabel = (date = new Date()): string => {
  const day = date.getDate();
  const month = date
    .toLocaleDateString("en-GB", { month: "short" })
    .toUpperCase();
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
};

// only groups plain 5-digit Swedish postal codes, e.g. "12345" -> "123 45"
export const formatSwedishPostalCode = (
  postalCode: string,
  country: string,
): string => {
  const isSwedish = country?.trim().toLowerCase() === "sweden";
  if (!isSwedish || !/^\d{5}$/.test(postalCode)) return postalCode;
  return `${postalCode.slice(0, 3)} ${postalCode.slice(3)}`;
};

export const timezone = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

// user input before we send it to the server
// this will also convert from our local time zone to utc.
export const local2utc = (
  date: string,
  time: string | null | undefined = undefined,
): string => {
  if (!date || !/^\d\d\d\d-\d\d-\d\d$/.test(date)) {
    throw new Error("date input must be iso 8601 yyyy-MM-dd: " + date);
  }
  if (!time) {
    time = "23:59:00";
  } else if (!/^\d\d:\d\d(:\d\d)?$/.test(time)) {
    throw new Error("time input must be either HH:mm or HH:mm:ss: " + time);
  } else if (time.length == 5) {
    time = `${time}:00`;
  }
  return new Date(`${date}T${time}`).toISOString();
};

// things we receive from the server before showing it to the user. converts to local time zone.
export const utc2local = (str: string | null | undefined): string => {
  if (!str) {
    return "-";
  }
  const date = new Date(str);
  return date.toLocaleString("sv-SE");
};

export const chunk = <T>(items: T[], size: number): T[][] => {
  const array = [];
  for (let i = 0; i < items.length; i += size) {
    array.push(items.slice(i, i + size));
  }
  return array;
};

export const compareDesc = (a: string, b: string) => {
  if (a && b) {
    return b.localeCompare(a);
  }
  if (a) {
    return -1;
  }
  if (b) {
    return 1;
  }
  return 0;
};

export const compareAsc = (a: string, b: string) => {
  if (a && b) {
    return a.localeCompare(b);
  }
  if (a) {
    return -1;
  }
  if (b) {
    return 1;
  }
  return 0;
};

type Searcher<T> = (skip: number, limit: number) => Promise<T[]>;
export const collectPaged = async <T>(
  getPage: Searcher<T>,
  pageSize: number,
): Promise<T[]> => {
  const results = [];
  let skip = 0;
  let result;
  do {
    result = await getPage(skip, pageSize);
    if (result?.length) {
      for (const r of result) {
        results.push(r);
      }
    }
    skip += pageSize;
  } while (result?.length === pageSize);
  return results;
};
